// メッセージの型定義
import { Citation } from './ApiTypes';

export interface Message {
  id: string;          // メッセージの一意ID
  content: string;     // メッセージ内容
  sender: 'user' | 'assistant';  // 送信者（ユーザーまたはAI）
  timestamp: Date;     // 送信時刻
  metadata?: {         // 追加のメタデータ（Knowledge Base対応）
    citations?: Citation[];      // 引用情報
    sessionId?: string;          // セッションID
    knowledgeBaseId?: string;    // Knowledge Base ID
    modelArn?: string;           // 使用したモデルのARN
    [key: string]: any;          // その他の拡張可能なメタデータ
  };
}

// TypeScript 5.x の satisfies 演算子を活用した型安全な定数定義
export const MESSAGE_SENDERS = {
  USER: 'user',
  ASSISTANT: 'assistant'
} as const satisfies Record<string, Message['sender']>;

// メッセージ作成のヘルパー関数（型安全）
export const createMessage = (
  content: string, 
  sender: Message['sender'],
  id?: string,
  metadata?: Message['metadata']
): Message => ({
  id: id ?? Date.now().toString(),
  content,
  sender,
  timestamp: new Date(),
  ...(metadata && { metadata })
});

// Knowledge Base対応のメッセージ作成ヘルパー
export const createKnowledgeBaseMessage = (
  content: string,
  citations: Citation[],
  sessionId: string,
  knowledgeBaseId: string,
  modelArn: string,
  id?: string
): Message => createMessage(
  content,
  MESSAGE_SENDERS.ASSISTANT,
  id,
  {
    citations,
    sessionId,
    knowledgeBaseId,
    modelArn
  }
);
